<template>
    <figure class="bg-black/20 aspect-square overflow-hidden motion-safe:zoom-anim">
        <img class="w-full h-full absolute block" :src="src" :alt="alt" loading="lazy" @load="loaded = true" :class="{ 'fade-in': loaded }" />
    </figure>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({ src: String, alt: String });
const loaded = ref(false);
</script>

<style scoped>
img {
    opacity: 0;
    @apply transition;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    position: absolute;
}
img.fade-in {
    opacity: 1;
}
</style>
